import { useSupabaseQuery, useSupabaseRow } from './useSupabaseQuery';
import type { Order, OrderSlot } from '../types/database';

export function useOrders(filters?: { status?: string; limit?: number; offset?: number; dateRange?: string }) {
	const limit = filters?.limit ?? 50;
	const offset = filters?.offset ?? 0;
	return useSupabaseQuery<Order & { users: { display_name: string | null; phone_number: string } | null; order_slots: { slot_name: string; value: Record<string, unknown> | null }[]; payment_intents: { status: string }[]; prodigi_orders: { status: string }[]; lob_orders: { status: string }[]; assets: { id: string; asset_type: string }[] }>(
		(client) => {
			let q = client
				.from('orders')
				.select('*, users(display_name, phone_number), order_slots(slot_name, value), payment_intents(status), prodigi_orders(status), lob_orders(status), assets(id, asset_type)', { count: 'exact' })
				.order('created_at', { ascending: false })
				.range(offset, offset + limit - 1);
			if (filters?.status) {
				q = q.eq('status', filters.status);
			}
			if (filters?.dateRange) {
				const now = new Date();
				let sinceDate: Date;
				switch (filters.dateRange) {
					case 'today':
						sinceDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
						break;
					case '7d':
						sinceDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
						break;
					case '30d':
						sinceDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
						break;
					default:
						sinceDate = new Date(0);
				}
				q = q.gte('created_at', sinceDate.toISOString());
			}
			return q;
		},
		[filters?.status, limit, offset, filters?.dateRange]
	);
}

export function useOrder(id: string | undefined) {
	return useSupabaseRow<Order>(
		'orders',
		id,
		'*'
	);
}

export function useOrderSlots(orderId: string | undefined) {
	return useSupabaseQuery<OrderSlot>(
		(client) =>
			client
				.from('order_slots')
				.select('*')
				.eq('order_id', orderId ?? '')
				.order('slot_name'),
		[orderId]
	);
}
